import { useRef } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { ImageItemContainer } from "@similarweb/ui-components";
import { Box } from "@similarweb/ui-components/foundations";

import useVisibilityWithOutsideClick from "app/pages/sales-intelligence/hooks/useVisibilityWithOutsideClick";
import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/modules/company-analysis/hooks/useCurrentStateAndParamsWithFixedDomain";
import DomainByCompanyAutocomplete from "app/pages/sales-intelligence/modules/company-autocomplete/components/DomainByCompanyAutocomplete/DomainByCompanyAutocomplete";
import useCompanyAutocompleteListQuery from "app/pages/sales-intelligence/modules/company-autocomplete/queries/useCompanyAutocompleteListQuery";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { StyledQueryBarItem } from "./styles";

const DomainBreadcrumbItem = ({
    onWebsiteClick,
    onOpen,
}: {
    onWebsiteClick: (domain: string) => void;
    onOpen?: () => void;
}) => {
    const { params } = useCurrentStateAndParamsWithFixedDomain();

    const ref = useRef<HTMLDivElement | null>(null);
    const { isVisible, onShow, onHide } = useVisibilityWithOutsideClick(ref);
    const isDataCreditsEnabled = salesSettingsHelper.isDataCreditsEnabled;

    const { data, isLoading } = useCompanyAutocompleteListQuery([params.key], isDataCreditsEnabled);

    const handleWebsiteClick = (domain: string) => {
        onHide();
        onWebsiteClick(domain);
    };

    const handleWebsiteSelectOpen = () => {
        onShow();
        onOpen?.();
    };

    return (
        <>
            <SWReactIcons
                iconName="chev-right"
                size="xs"
                iconColor={colorsPalettes.carbon[300]}
            />
            {isVisible ? (
                <Box
                    ref={ref}
                    position="relative"
                    top="-20px"
                >
                    <Box
                        position="absolute"
                        minWidth="320px"
                        zIndex={30}
                    >
                        <DomainByCompanyAutocomplete
                            domains={data?.[0].domainsInfo}
                            isLoading={isLoading}
                            onWebsiteClick={handleWebsiteClick}
                        />
                    </Box>
                </Box>
            ) : (
                <StyledQueryBarItem
                    text={params.key}
                    secondaryText=""
                    iconName="arrow"
                    iconSize="7px"
                    image="website-analysis"
                    onItemClick={handleWebsiteSelectOpen}
                    renderImageComponent={({ isActive }) => (
                        <ImageItemContainer
                            borderColor={isActive ? colorsPalettes.blue[400] : colorsPalettes.carbon[50]}
                        >
                            <SWReactIcons
                                iconName="website-analysis"
                                size="xs"
                                iconColor={isActive ? colorsPalettes.blue[400] : colorsPalettes.carbon[500]}
                            />
                        </ImageItemContainer>
                    )}
                />
            )}
        </>
    );
};

export default DomainBreadcrumbItem;
